export const COMBINED_CASHFLOW = "COMBINED_CASHFLOW";
export const LOAN_CASHFLOW = "LOAN_CASHFLOW";
export const SWAP_CASHFLOW = "SWAP_CASHFLOW";
export const CORRIDOR_CASHFLOW = "CORRIDOR_CASHFLOW";
export const CAP_CASHFLOW = "CAP_CASHFLOW";
export const COLLAR_CASHFLOW = "COLLAR_CASHFLOW";
export const ANY_LENDER_APPROVED_CASHFLOW = "ANY_LENDER_APPROVED_CASHFLOW";
export const FLOOR_CASHFLOW = "FLOOR_CASHFLOW";
export const HEDGE_CASHFLOW = "HEDGE_CASHFLOW";
export const DEBT_VALUATION = "DEBT_VALUATION";
